// extracted by mini-css-extract-plugin
export default {"title":"AddClientAllocation_title__D6F5i"};